var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aula-card aula-card-variables",attrs:{"aria-disabled":_vm.disabled}},[_c('div',{staticClass:"card-thumbnail"},[_vm._t("thumbnail")],2),_vm._v(" "),_c('div',{staticClass:"card-description"},[_vm._t("description")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }